module.exports = __webpack_public_path__ + "media/src/assets/images/empty_profile-77f5794e2eb49f7989b8f85e92cfa4e0.png";